import { render, staticRenderFns } from "./GuidesEdit.vue?vue&type=template&id=169ba4f0"
import script from "./GuidesEdit.vue?vue&type=script&lang=js"
export * from "./GuidesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports